import axios from 'axios'

const instance = axios.create({
  baseURL: import.meta.env.VITE_JOURNEY_PLANNER_API_BASE_URL,
  timeout: 15000,
  headers: {
    'X-Api-Key': import.meta.env.VITE_JOURNEY_PLANNER_API_KEY,
  }
})

export default {
  search(params) {
    return instance({
      url: '/search',
      method: 'post',
      params: params,
    })
  },
}
